/**
 * Formats a date for display.
 *
 * @param {string} dateString The ISO date string.
 *
 * @returns {string} The formatted date.
 */
export default function formatDate( dateString ) {
	return new Date( dateString ).toLocaleDateString( undefined, {
		year: "numeric",
		month: "short",
		day: "numeric",
	} );
}
